'use client';

import React from 'react';

export const ImageAnnotationTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/ImageAnnotation'),
);

export const VideoAnnotationTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/VideoAnnotation'),
);

export const VideoPlaybackAnnotationTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/VideoPlaybackAnnotation'),
);

export const SegmentAnnotationTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/SegmentAnnotation'),
);

export const CategorizationTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/categorization'),
);

export const CategorizationV2Task = React.lazy(
  () => import('react-scale/components/scalers/tasks/categorization/CategorizationV2'),
);

export const CategorizationTaskReview = React.lazy(
  () => import('react-scale/components/scalers/tasks/categorization/CategorizationTaskReview'),
);

export const CategorizationCreateBenchmark = React.lazy(
  () => import('react-scale/components/scalers/tasks/categorization/CategorizationCreateBenchmark'),
);

export const CategorizationBenchmarkFeedback = React.lazy(
  () =>
    import('react-scale/components/scalers/tasks/categorization/CategorizationBenchmarkFeedback'),
);

export const DataCollectionTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/DataCollection'),
);

export const GenericDataCollectionTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/GenericDataCollection'),
);

export const AudioTranscriptionV2Task = React.lazy(
  () => import('react-scale/components/scalers/tasks/AudioTranscriptionV2'),
);

export const TranscriptionTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/Transcription'),
);

export const ComparisonTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/Comparison'),
);

export const NamedEntityRecognitionTask = React.lazy(
  () =>
    import(
      'react-scale/components/scalers/tasks/namedEntityRecognition/NamedEntityRecognitionTask'
    ),
);

export const TaskLevelVideoAnnotationReview = React.lazy(
  () => import('react-scale/components/scalers/tasks/TaskLevelVideoAnnotation'),
);

export const TextCollectionTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/textcollection/TextCollectionTask'),
);

export const TextCollectionTaskReview = React.lazy(
  () => import('react-scale/components/scalers/tasks/textcollection/TextCollectionTaskReview'),
);

export const TextCollectionIframeTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/textcollection/TextCollectionIframeTask'),
);

export const TextCollectionTemplateTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/textcollection/TextCollectionTemplateTask'),
);

export const TextCollectionCreateBenchmark = React.lazy(
  () => import('react-scale/components/scalers/tasks/textcollection/TextCollectionCreateBenchmark'),
);

export const DocumentTranscriptionTask = React.lazy(
  () =>
    import('react-scale/components/scalers/tasks/documenttranscription/DocumentTranscriptionTask'),
);

export const DocumentTranscriptionReview = React.lazy(
  () =>
    import(
      'react-scale/components/scalers/tasks/documenttranscription/DocumentTranscriptionReview'
    ),
);

export const DocumentTranscriptionAudit = React.lazy(
  () =>
    import('react-scale/components/scalers/tasks/documenttranscription/DocumentTranscriptionAudit'),
);

export const DocumentModelReview = React.lazy(
  () => import('react-scale/components/scalers/tasks/documentmodel/DocumentModelReview'),
);

export const DocumentModelAudit = React.lazy(
  () => import('react-scale/components/scalers/tasks/documentmodel/DocumentModelAudit'),
);

export const DocumentTranscriptionCreateBenchmark = React.lazy(
  () =>
    import(
      'react-scale/components/scalers/tasks/documenttranscription/DocumentTranscriptionCreateBenchmark'
    ),
);

export const MultiModalTranscriptionTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/MultiModalTranscription'),
);

export const ChatTask = React.lazy(() => import('react-scale/components/scalers/tasks/Chat'));

export const ChatV2 = React.lazy(() => import('react-scale/components/scalers/tasks/ChatV2'));

export const MultiChatTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/MultiChat'),
);

export const SweAgentTask = React.lazy(
  () => import('react-scale/components/scalers/tasks/SweAgent'),
);

export const FrontierData = React.lazy(
  () => import('react-scale/components/scalers/tasks/FrontierData'),
);

export const CruiseControl = React.lazy(
  () => import('react-scale/components/scalers/tasks/CruiseControl'),
);

export const TimeTrackingTasksPage = React.lazy(
  () => import('@scale/outlier-components/components/TimeTracking/index'),
);
